import axios from "axios";
const jsonConfig = require("../../Config.json");

const updatevetcandidatetestbyid = async (payload) => {
    let allResponse = {}
    try {
        const getallresponse =await axios.put(
            jsonConfig.apiUrl + "vetmanagecandidatetest",
            payload,
            {
              headers: {
                "x-functions-key": jsonConfig.key,
              },
            }
          );
        
        allResponse = getallresponse;
        return Promise.resolve(allResponse)
    }
    catch (error) {
        return Promise.reject(error)
    }
}

export default updatevetcandidatetestbyid;